import { usePropertyRentalPreferredTerm } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { PreferredTermTypeOptions } from '@apply/constants';
import { useBorrowerLoanType } from '../../../../queries/BorrowerFields/CoreFields';

export interface PreferredTermProps {
    propertyGuid: string;
    width?: string;
    required?: boolean;
    isReview?: boolean;
}

export const PreferredTerm: React.FC<PreferredTermProps> = ({ propertyGuid, required = false, width, isReview = false }) => {
    const label = 'Preferred Term';
    const [loanType] = useBorrowerLoanType();
    const [preferredTerm, set_preferredTerm] = usePropertyRentalPreferredTerm(propertyGuid);

    const preferredTermList = loanType
        ? PreferredTermTypeOptions.filter((o) => o.loanTypes.includes(loanType)).map((o) => ({
              display: o.name,
              value: o.id,
          }))
        : [];

    const findPreferredTermByValue = (value: number | undefined) => {
        return preferredTermList.find((bt) => bt.value == value)?.display;
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={findPreferredTermByValue(preferredTerm)}
                />
            ) : (
                <DropDownBox
                    id={'preferredTermDropDown'}
                    value={preferredTerm}
                    onChange={(value) => set_preferredTerm(value)}
                    required={required}
                    dataSource={preferredTermList}
                    displayExpr='display'
                    valueExpr='value'
                    width={width}
                    label={label}
                />
            )}
        </>
    );
};
